import { EventsEmit } from "../../configs/events"

// "Could not disable the lock: The function is not supported for this lock."  ->  title + detail line
export const splitToastMessage = (message: string): [string, string] => {
    for (let i = 8; i < message.length - 2; i++) {
        const two = message.slice(i, i + 2)
        if (two === '. ' || two === ': ')
            return [message.slice(0, i), message.slice(i + 2)]
    }
    return [message.replace(/\.$/, ''), '']
}

// Solid colour cards with white text (contrast checked: title 5:1+, detail 4.5:1+ on the lighter end of each gradient).
const LOOK = {
    success: { from: '#157a41', to: '#0e6635', glow: 'rgba(14, 102, 53, 0.35)' },
    error: { from: '#c73232', to: '#a32424', glow: 'rgba(163, 36, 36, 0.35)' }
}

// Shown with the app's global toast (App.tsx). Only these toasts get this look; nothing else in the app changes.
export const toastMsg = (status: 'success' | 'error', message: string) => {
    const [title, detail] = splitToastMessage(message)
    const look = LOOK[status]
    EventsEmit('app', {
        info: {
            status,
            message: (
                <div style={{ flex: 1, textAlign: 'left' }}>
                    <div style={{ fontWeight: 600, fontSize: 14.5, lineHeight: 1.35, letterSpacing: 0.1, color: '#fff' }}>{title}</div>
                    {detail && <div style={{ marginTop: 3, fontSize: 13, lineHeight: 1.5, color: 'rgba(255, 255, 255, 0.92)' }}>{detail}</div>}
                </div>
            ),
            options: {
                position: 'top-center',
                duration: status === 'error' ? 9000 : 4000,
                style: {
                    background: `linear-gradient(135deg, ${look.from}, ${look.to})`,
                    color: '#fff',
                    border: '1px solid rgba(255, 255, 255, 0.18)',
                    borderRadius: 14,
                    padding: '14px 20px 14px 16px',
                    boxShadow: `0 14px 34px ${look.glow}, 0 2px 6px rgba(17, 24, 39, 0.12)`,
                    minWidth: 300,
                    maxWidth: 480
                },
                // white disc with a coloured tick / cross
                iconTheme: { primary: '#fff', secondary: look.to }
            }
        }
    })
}
